import { Backdrop, CircularProgress, Grid, Typography } from '@mui/material';

export interface BakeasyLoaderProps {
  loader?: BakeasyLoaderProp;
}

export interface BakeasyLoaderProp {
  isLoading?: boolean;
  message?: string;
}

function BakeasyLoader(props: BakeasyLoaderProps) {
  return (
    <Backdrop
      sx={{ color: 'white', zIndex: theme => theme.zIndex.drawer + 1 }}
      open={props?.loader?.isLoading ? props?.loader?.isLoading : false}
    >
      <Grid sx={{ backgroundColor: '#D7DBDD', padding: 2 }}>
        <Grid
          container
          direction={'column'}
          alignItems={'center'}
          rowGap={1}
          justifyContent={'center'}
        >
          <CircularProgress color="primary" />
          <Typography color="primary" fontWeight={600} marginTop={1} fontSize={18}>
            {props?.loader?.message ? props?.loader?.message : 'Please wait...'}
          </Typography>
        </Grid>
      </Grid>
    </Backdrop>
  );
}

export default BakeasyLoader;
